var scroll_pos = 0;


var h_tm = null;
var scroll_dir = 0;
var scroll_turn_pos = 0;
var scroll_last_pos = 0;
$(document).ready(function () {
	// scroll_pos = $(window).scrollTop();
	// if (!is_mobile()) $('#header').hover(function(e) {
	//   //if ($(e.target).is('svg')) return false;
	//   window.setTimeout(function() {
	//   $('#header').addClass('header_alt2');
	//   if (h_tm) window.clearTimeout(h_tm);
	//   h_tm = null;
	//   }, 10);
	// }, function(e) {
	//   //if ($(e.target).is('svg')) return false;
	//   if (!window.stop1) {
	//     if (h_tm) window.clearTimeout(h_tm);
	//     h_tm = window.setTimeout(function() { $('#header').removeClass('header_alt2');}, 300);
	//   }
	//   window.stop1 = false;
	// });
	// $('#header').on('click', function(e) {
	//   var o = $(e.target).parents().add(e.target).filter('a');
	//   if (o.length) return true;
	//   window.allow_scroll = false; $('body').addClass('do_scrolling');
	//   $('html,body').animate({scrollTop: 0}, 1000, function() {window.allow_scroll = true; $('body').removeClass('do_scrolling'); });
	// });
	if (!is_mobile()) $('#header_line').hover(function () {
		$('#header').addClass('header_alt2');
	}, function () {
	})
	scroll_turn_pos = scroll_last_pos = $(window).scrollTop();
	$(window).on('scroll', function () {
		scroll_pos = $(window).scrollTop();
		if (scroll_pos > scroll_last_pos) {
			if (scroll_dir != 1) {
				scroll_dir = 1;
				scroll_turn_pos = scroll_pos;
			}
		} else if (scroll_pos < scroll_last_pos) {
			if (scroll_dir != 2) {
				scroll_dir = 2;
				scroll_turn_pos = scroll_pos;
			}
		}
		if (scroll_dir == 1) {
			if ($('#news').length) {
				if (scroll_pos > 600 + scroll_turn_pos && scroll_pos < $('#news').height()) $('#header,#header2').addClass('header_alt'); else $('#header,#header2').removeClass('header_alt');
			}
			if ($(window).width() < 600) {
				if (scroll_pos > 1200 + scroll_turn_pos && !$('body').hasClass('mob-menu')) $('#header:not(.menu-open)').addClass('header_hid');
			}
		} else if (scroll_dir == 2) {
			if ($(window).width() < 600) {
				$('#header').removeClass('header_hid');
				if ($('#news').length) {
					if (scroll_pos < -600 + scroll_turn_pos) $('#header,#header2').removeClass('header_alt');
				}
			} else {
				if ($('#news').length) {
					$('#header,#header2').removeClass('header_alt');
				}
			}
		}
		scroll_last_pos = scroll_pos;
		// if (document.body.scrollHeight > $(window).height()) $('#header .progress div').show().css({width: Math.round(100*($(window).scrollTop()/(document.body.scrollHeight - $(window).height()))) + '%'});
		// else $('#header .progress div').hide();

		$('#news .img .over').css({opacity: Math.max(0, Math.min(1, (scroll_pos - 270) / $('#news .img').height()))});
		$('#news .img').toggleClass('img_fix', scroll_pos >= 200);

		$('#blocks .img .over').css({opacity: Math.max(0, Math.min(1, (scroll_pos - 100) / $('#blocks .img').height()))});
		$('#blocks .img').toggleClass('img_fix', true);

		$('.news_item_wide').each(function () {
			y = $(this).offset().top;
			h = $(this).height();
			if (scroll_pos >= y - 70) {
				$(this).find('.over').css({opacity: Math.max(0, Math.min(1, (scroll_pos - y) / h))});
				$(this).addClass('img_fix'); //.css('background-position-y', 70).css('background-attachment', 'fixed');
			} else {
				$(this).find('.over').css({opacity: ''});
				$(this).removeClass('img_fix'); //.css('background-position-y', '').css('background-attachment', '');
			}
		});
	});
	/*
	$('#header .menu a').hover(function() {
	  if (window.tm_menu) window.clearTimeout(window.tm_menu);
	  window.tm_menu = window.setTimeout(function() {
		$('body').addClass('bd_search');
		window.stop1 = true;
	  }, 1000);
	}, function() {
	  if (window.tm_menu) window.clearTimeout(window.tm_menu);
	});
	*/
	// $('#header .switch').on('click', function() {
	//   // scroll_save();
	//   $('body').addClass('bd_search');
	//   return false;
	// });
	$('#catalog').hover(function () {
	}, function () {
		//$('body').removeClass('bd_search');
		//window.setTimeout(function() { $('#header').removeClass('header_alt2');}, 300);
	});
	$('#news .page_content img').on('load', function () {
		if ($(this).width() > 680 && !$(this).parent().is('center') && !$(this).parents('.ba-slider').length) {
			$(this).before('<center></center>')
			$(this).next().filter('br').remove();
			$(this).appendTo($(this).prev());
		}
		if ($(this).width() > 0 && $(this).attr('data-retina') && $(window).width() > 480 && (window.devicePixelRatio >= 1.5 || (window.matchMedia && window.matchMedia("(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)").matches))) {
			$(this).attr('data-retina', '').each(function () {
				if ($(this).attr('src').indexOf('@x1') != -1) $(this).attr('src', $(this).attr('src').replace('@x1', '@x2'));
				else $(this).attr('src', $(this).attr('src').replace(/(\.(jpg|png|gif))$/g, '_x2$1'));
			}).attr('width', $(this).width()).attr('height', $(this).height());
		}
	}).each(function () {
		if ($(this).width() > 680 && !$(this).parents('.ba-slider').length) {
			$(this).before('<center></center>');
			$(this).next().filter('br').remove();
			$(this).appendTo($(this).prev());
		}
		if ($(this).width() > 0 && $(this).attr('data-retina') && $(window).width() > 480 && (window.devicePixelRatio >= 1.5 || (window.matchMedia && window.matchMedia("(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)").matches))) {
			$(this).attr('data-retina', '').each(function () {
				if ($(this).attr('src').indexOf('@x1') != -1) $(this).attr('src', $(this).attr('src').replace('@x1', '@x2'));
				else $(this).attr('src', $(this).attr('src').replace(/(\.(jpg|png|gif))$/g, '_x2$1'));
			}).attr('width', $(this).width()).attr('height', $(this).height());
		}
	});
	$('.news_list .item').on('click', function (e) {
		if (window.stop_click) return false;
		if ($(e.target).parents().add(e.target).filter('a').length) return true;
		$(this).find('a:first').each(function () {
			document.location.href = this.href;
		});
	});
	$('#catalog .cats').on('click', function (e) {
		if ($(e.target).parents().add(e.target).filter('a').length) return true;
		$(this).find('a.r').trigger('click');
	});
	// setTimeout(function() {
	//   if (document.location.hash && /^#[a-zA-Z01-9_]+$/.test(document.location.hash)) {
	//     var target = $(document.location.hash);
	//     if (!target.length) target = $('[name=' + document.location.hash.slice(1) +']');
	//     if (target.length) {
	//       var targetOffset = target.offset().top;
	//       if (targetOffset > 70) targetOffset -= 70;
	//       $(window).scrollTop(targetOffset);
	//     }
	//   }
	// }, 100);
});

function client_go(el, url) {
	window.open(url)
}

function listenClicks(evt) {
	evt = (evt) ? evt : ((event) ? event : null);
	if (evt) {
		el = (evt.target) ? evt.target : ((evt.srcElement) ? evt.srcElement : null);
		if ($(el).parents('#catalog').length) return;
		if (last_dropmenu && (el == last_dropmenu || el == last_dropmenu_box || (el.className && el.className.indexOf('ignore_hide') != -1))) return;
		while (el.parentNode) {
			el = el.parentNode;
			if (last_dropmenu && (el == last_dropmenu || el == last_dropmenu_box || (el.className && el.className.indexOf('ignore_hide') != -1))) return;
		}
		if (last_dropmenu) {
			window.stop_click = true;
			window.setTimeout(function () {
				window.stop_click = false;
			}, 200);
			drophide(true);
			return false
		}
		// if ($('#catalog').is(":visible")) {
		//   window.stop_click = true;
		//   window.setTimeout(function() {window.stop_click = false;}, 200);
		//   $('body').removeClass('bd_search');
		//   $('.button-more').removeClass('hidden');
		//   $('.tags.tags_').removeClass('tags-view-all');
		//   // window.setTimeout(function() { $('#header').removeClass('header_alt2');}, 300);
		//   return false;
		// }
	}
	//return true;
}

$(document).on('mousedown touchend', listenClicks);


function process_keyCode(key, alt, ctrl, shift, in_input) {
	if (key == 27) { // ESC
		if (last_dropmenu) {
			drophide();
			return true;
		} else if ($('#TB_window').length) {
			if ($('#TB_window').hasClass('tb_invite') && !$('#inv_but').hasClass('button_white')) $('#inv_but').shake(3, 5, 300); else tb_remove();
			return true;
		} else if ($('#catalog').is(":visible")) {
			$('body').removeClass('bd_catalog');
			if ($(window).width() < 600) $(window).scrollTop(window.lastScrolltop);
			setTimeout(function () {
				$('body').removeClass('bd_search bd_menu');
			}, 500);
			$('.button-more').removeClass('hidden');
			$('.tags.tags_').removeClass('tags-view-all');
			// window.setTimeout(function() { $('#header').removeClass('header_alt2');}, 300);
			return false;
		}
	}
	return false;
}

$(document).ready(function () {
	if (!is_mobile()) $(document).on('keydown', function (e) {
		var key = e.keyCode ? e.keyCode : e.charCode;
		if (key == 9 && $(e.target).is('input, textarea') && $(e.target).hasClass('notab')) {
		} else if ((key == 13 || key == 10) && $(e.target).attr('data-onenter')) {
			$($(e.target).attr('data-onenter')).trigger('click');
		} else if ((key == 13 || key == 10 || key == 37 || key == 38 || key == 39 || key == 40) && $(e.target).is('textarea')) {
		} else if (process_keyCode(key, e.altKey, e.metaKey || e.ctrlKey, e.shiftKey, $(e.target).is('input, textarea') && ($(e.target).val() || $(e.target).attr('tabindex')))) {
			e.preventDefault();
			return false;
		}
	});
});

// var search_tm = null;
// var search_tm2 = null;

// function do_search() {
//   if (/\S{2}/.test($('#catalog .s-input .input').attr('value'))) {
//     $('#catalog .tags_').hide();
//     $('#catalog .results').html('');
// 	  if (search_tm2) window.clearTimeout(search_tm2);
// 		search_tm2 = window.setTimeout(function() {
// 			$('#catalog .loading').show();
// 			window.setTimeout(function() {$('#catalog .loading').addClass('loading_on');}, 50);
// 		}, 200);
//     $('#catalog .results').load('/api/user/?action=blog_autocomplete&'+($('body').hasClass('bd_lang4') ? 'do_lang=4&' : '')+($('body').hasClass('bd_lang2') ? 'do_lang=2&' : '')+'q=' + encodeURIComponent($('#catalog .s-input .input').attr('value')), function() {

//       if (search_tm2) window.clearTimeout(search_tm2);
//       $('#catalog .loading').hide().removeClass('loading_on');
//       $('#catalog .button-more').hide();
//       $('.bottom-line').removeClass('hidden');
//       $('#catalog .results').css({'max-height': '74vh'});
//     });
//   } else {
//     $('#catalog .results').css({'max-height': '4vh'});
//     $('#catalog .tags_').css({display: ''});
//       $('.bottom-line').addClass('hidden');
//       $('#catalog .loading').hide().removeClass('loading_on');
//   }
// }


// function _do_search() {
//   if (search_tm) window.clearTimeout(search_tm);
//   search_tm = window.setTimeout(do_search, 500);
// }

// $(document).ready(function() {
//   $("#catalog .s-input .input").on('keyup', _do_search);
// });

// function clipboard(o) {
//   o.select();
//   try {
//     var successful = document.execCommand('copy');
//   } catch(err) {}
// }

function clipboard(el) {
	result = true;
	var clipin = $("<input type=\"text\" value=\"\"/>");
	clipin.css({position: 'fixed', top: 50, left: 50});
	$("body").append(clipin);
	var txt = '';
	if (typeof el == 'string') {
		clipin.val(txt = el);
	} else if ($(el).is('input, textarea')) {
		clipin.val(txt = $(el).val());
	} else {
		clipin.val(txt = $(el).text());
	}
	if (is_ios()) {
		clipin.get(0).setSelectionRange(0, 999999);
	} else clipin.select();
	try {
		result = document.execCommand('copy');
	} catch (err) {
		result = false;
	}
	clipin.remove();
	return result;
}

jQuery.fn.blink = function () {
	this.each(function () {
		$(this).animate({opacity: 0.1}, function () {
			$(this).animate({opacity: 1}, function () {
				$(this).animate({opacity: 0.1}, function () {
					$(this).animate({opacity: 1}, function () {
						$(this).animate({opacity: 0.1}, function () {
							$(this).animate({opacity: 1});
						});
					});
				});
			});
		});
	});
	return this;
};

function blog_comment_submit(frm) {
	if (!frm.rdescr.value) {
		$(frm.rdescr).blink();
		return false;
	}
	if (!frm.rname.value) {
		$(frm.rname).blink();
		return false;
	}
	if ($(frm).hasClass('frm_sent')) return false;
	$(frm).addClass('frm_sent');
	window.last_form = frm;
	$('#com' + $(frm).attr('rel')).load($('body').attr('rel') + 'blog.html?action=post&' + $(frm).serialize(), function () {
		$(window.last_form).removeClass('frm_sent');
		window.last_form.rdescr.value = '';
	});
	return false;
}

_mobile_scroll = 0;
// function scroll_save() {
//   _mobile_scroll = $(window).scrollTop();
//   $(window).scrollTop(0);
// }
// function scroll_restore() {
//   $(window).scrollTop(_mobile_scroll);
// }


// Call & init
$(document).ready(function () {
	$(".ba-slider").each(function () {
		var cur = $(this);
		// Adjust the slider
		var width = cur.width() + "px";
		cur.find("img").css("width", width).css("height", 'auto');
		// Bind dragging events
		drags(cur.find(".handle"), cur.find(".resize"), cur);
	});
});

// Update sliders on resize.
// Because we all do this: i.imgur.com/YkbaV.gif
$(window).resize(function () {
	$(".ba-slider").each(function () {
		var cur = $(this);
		var width = cur.width() + "px";
		cur.find("img").css("width", width).css("height", 'auto');
	});
});

function drags(dragElement, resizeElement, container) {
	// Initialize the dragging event on mousedown.
	dragElement
		.on("mousedown touchstart", function (e) {
			dragElement.addClass("draggable");
			resizeElement.addClass("resizable");

			// Check if it's a mouse or touch event and pass along the correct value
			var startX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

			// Get the initial position
			var dragWidth = dragElement.outerWidth(),
				posX = dragElement.offset().left + dragWidth - startX,
				containerOffset = container.offset().left,
				containerWidth = container.outerWidth();

			// Set limits
			minLeft = containerOffset + 10;
			maxLeft = containerOffset + containerWidth - dragWidth - 10;

			// Calculate the dragging distance on mousemove.
			dragElement
				.parents()
				.on("mousemove touchmove", function (e) {
					// Check if it's a mouse or touch event and pass along the correct value
					var moveX = e.pageX ? e.pageX : e.originalEvent.touches[0].pageX;

					leftValue = moveX + posX - dragWidth;

					// Prevent going off limits
					if (leftValue < minLeft) {
						leftValue = minLeft;
					} else if (leftValue > maxLeft) {
						leftValue = maxLeft;
					}

					// Translate the handle's left value to masked divs width.
					widthValue =
						(leftValue + dragWidth / 2 - containerOffset) *
						100 /
						containerWidth +
						"%";

					// Set the new values for the slider and the handle.
					// Bind mouseup events to stop dragging.
					$(".draggable")
						.css("left", widthValue)
						.on("mouseup touchend touchcancel", function () {
							$(this).removeClass("draggable");
							resizeElement.removeClass("resizable");
						});
					$(".resizable").css("width", widthValue);
				})
				.on("mouseup touchend touchcancel", function () {
					dragElement.removeClass("draggable");
					resizeElement.removeClass("resizable");
				});
			e.preventDefault();
		})
		.on("mouseup touchend touchcancel", function (e) {
			dragElement.removeClass("draggable");
			resizeElement.removeClass("resizable");
		});
}

function htmlenc(s) {
	return s.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


var scroll_listener = function (e) {
	if ($('body').hasClass('bd_search') || $('body').hasClass('bd_menu') || $('body').hasClass('bd_auth')) {
		if (e.type == 'mousewheel') scrollTo = ((e.originalEvent ? e.originalEvent.wheelDelta : e.wheelDelta) * -1);
		else if (e.type == 'DOMMouseScroll') scrollTo = 40 * (e.originalEvent ? e.originalEvent.detail : e.detail);

		if ($('body').hasClass('bd_search')) {
			$('#catalog .results .in').scrollTop(scrollTo + $('#catalog .results .in').scrollTop());
		}
		e.preventDefault();
		return false;
	}
}
this.addEventListener('mousewheel', scroll_listener, {passive: false});
this.addEventListener('DOMMouseScroll', scroll_listener, {passive: false});


function setCookie(name, value, seconds) {
	let expires;
	if (seconds === false) expires = ""; // session cookie
	else if (seconds) {
		let d = new Date();
		d.setTime(d.getTime() + (seconds * 1000));
		expires = ";expires="+ d.toUTCString();
	} else expires = ";expires=0";
	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + ";path=/; secure";
}
function getCookie(name) {
	let b = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
	return b ? decodeURIComponent(b.pop()) : '';
}

function clearCookies() {
	let cookies = document.cookie.split(";");
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i].trim();
		let eqPos = cookie.indexOf("=");
		let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		if (name != 'ua_2022') {
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
		}
	}

}